import SellerFilter from "@containers/SellerFilter";
import MarketplaceFilter from "@containers/MarketplaceFilter";
import ServiceFilter from "@containers/ServiceFilter";
import DateRangeFilter from "./DateRangeFilter";
import SearchFilter from "./SearchFilter";
import SearchFilterNew from "./SearchFilterNew";
import MultiSelectFilter, { OptionType } from "./MultiSelectFilter";
import { FilterTypes } from "./types";
import StatusFilter from "./StatusFilter";
import ParcelStatusFilter from "./ParcelStatusFilter";
import DisposedByFilter from "./DisposedByFilter";
import StateFilter from './StateFilter';

interface FilterProps {
  type: FilterTypes;
  initialValue: string[];
  onChange: (v: string[], rv?: string[]) => void;
  placeholder?: string;
  asPanel?: boolean;
  data?: OptionType[];
}

const Filter = ({
  type,
  initialValue,
  onChange,
  placeholder,
  asPanel,
  data,
}: FilterProps) => {
  if (type === FilterTypes.SELLER) {
    return (
      <SellerFilter
        initialValue={initialValue}
        onChange={onChange}
        asPanel={asPanel}
      />
    );
  }
  if (
    (type === FilterTypes.MARKETPLACE)
    || (type === FilterTypes.MARKETPLACE_FILTERED)
  ) {
    return (
      <MarketplaceFilter
        initialValue={initialValue}
        onChange={onChange}
        asPanel={asPanel}
        isFiltered={type === FilterTypes.MARKETPLACE_FILTERED}
      />
    );
  }
  if (
    (type === FilterTypes.SERVICE_PICKUP)
    || (type === FilterTypes.SERVICE_PARCELS)
    || (type === FilterTypes.SERVICE_RETURNS)
    || (type === FilterTypes.SERVICE_PROBLEMATIC)
  ) {
    return (
      <ServiceFilter
        initialValue={initialValue}
        onChange={onChange}
        asPanel={asPanel}
        type={type}
      />
    );
  }

  if (type === FilterTypes.DATE_RANGE) {
    return (
      <DateRangeFilter
        initialValue={initialValue}
        onChange={onChange}
        asPanel={asPanel}
        placeholder={placeholder}
      />
    );
  }
  if (type === FilterTypes.SEARCH) {
    return (
      <SearchFilter
        initialValue={initialValue?.[0]}
        onChange={onChange}
        placeholder={placeholder}
        asPanel={asPanel}
      />
    );
  }
  if (type === FilterTypes.MULTI_SEARCH) {
    return (
      <SearchFilter
        initialValue={initialValue?.[0]}
        onChange={onChange}
        placeholder={placeholder}
        multi
        asPanel={asPanel}
      />
    );
  }
  if (type === FilterTypes.MULTI_SEARCH_NEW) {
    return (
      <SearchFilterNew
        initialValue={initialValue?.[0]}
        onChange={onChange}
        placeholder={placeholder}
        multi
        asPanel={asPanel}
      />
    );
  }
  if (type === FilterTypes.MULTI_SEARCH_OR_NAME) {
    return (
      <SearchFilter
        initialValue={initialValue?.[0]}
        onChange={onChange}
        placeholder={placeholder}
        multiOrName
        asPanel={asPanel}
      />
    );
  }
  if (type === FilterTypes.MULTI_SELECT) {
    return (
      <MultiSelectFilter
        onChange={onChange}
        initialValue={initialValue}
        isFetching={false}
        data={data || []}
        placeholder={placeholder}
        asPanel={asPanel}
      />
    );
  }
  if (type === FilterTypes.PARCEL_STATUS) {
    return (
      <ParcelStatusFilter
        initialValue={initialValue}
        onChange={onChange}
        asPanel={asPanel}
      />
    );
  }
  if (type === FilterTypes.DISPOSED_BY) {
    return (
      <DisposedByFilter
        initialValue={initialValue}
        onChange={onChange}
        asPanel={asPanel}
      />
    );
  }
  if (type === FilterTypes.STATUS) {
    return (
        <StatusFilter
            initialValue={initialValue}
            onChange={onChange}
            asPanel={asPanel}
        />
    );
  }
  if (type === FilterTypes.STATE) {
    return (
        <StateFilter
            initialValue={initialValue}
            onChange={onChange}
            asPanel={asPanel}
        />
    );
  }
  return null;
}

export default Filter;
